export class RntFeedModel {
  [key: string]: any;

  public ret_id: number;
  public rpt_date: string;
  public rpt_date_from: string;
  public rpt_date_to: string;
  public save_time: string;
  public opr_id: string;
  public retention_type: string;
  public lob: string;
  public srccustomeraccountid: string;
  public fixedaccountnumber: string;
  public mobileaccountnumber: string;
  public corp: string;
  public house: string;
  public cust: string;
  public disconnect_flag: number;
  public save_flag: number;
  public save_flag_30: number;
  public save_flag_60: number;
  public accountstatussoi: string;
  public accountstatuseoi: string;
  public accountstatuseod30: string;
  public accountstatuseod60: string;
  public productdescsoi: string;
  public productdesceoi: string;
  public productdesceod30: string;
  public productdesceod60: string;
  public workordertype: string;
  public workorderstatus: string;
  public workorderproductsadded: string;
  public workorderproductsremoved: string;
  public voicecombostrsoi: string;
  public voicecombostreoi: string;
  public voicecombostreod30: string;
  public voicecombostreod60: string;
  public videotiersoi: string;
  public videotiereoi: string;
  public videotiereod30: string;
  public videotiereod60: string;
  public dataspeedtiersoi: string;
  public dataspeedtiereoi: string;
  public dataspeedtiereod30: string;
  public dataspeedtiereod60: string;
  public dataspeedtierdownsoi: number;
  public dataspeedtierdowneoi: number;
  public dataspeedtierdowneod60: number;
  public dataspeedtierdowneod30: number;
  public soi_ftth: number;
  public eoi_ftth: number;
  public eod_30_ftth: number;
  public eod_60_ftth: number;
  public fiber_eligible_flag: number;
  public mt_disco_flag: number;
  public mt_chc_id: string;
  public movetransferaccountstatusdesc: string;
  public movetransferaccountstatusdesceod30: string;
  public retentionsaverevenue: number;
  public net_revenue_change: number;
  public net_revenue_change_30: number;
  public net_revenue_change_60: number;
  public videorevenuesoi: number;
  public datarevenuesoi: number;
  public voicerevenuesoi: number;
  public otherrevenuesoi: number;
  public videorevenueeoi: number;
  public datarevenueeoi: number;
  public voicerevenueeoi: number;
  public otherrevenueeoi: number;
  public videorevenueeod30: number;
  public datarevenueeod30: number;
  public voicerevenueeod30: number;
  public otherrevenueeod30: number;
  public videorevenueeod60: number;
  public datarevenueeod60: number;
  public voicerevenueeod60: number;
  public otherrevenueeod60: number;
  public src_interaction_id: string;
  public adj_amt: number;
  public mkt: string;
  public ctype_code: string;
  public ctype_desc: string;
  public customer_class: string;
  public call_type: string;
  public contact_comment: string;
  public pia_revenue: number;
  public cust_repeated_flag: string;
  public mt_code: string;
  public save_type: string;
  public load_ts: string;
  public pr_status_id: number;
  public created_by: string;
  public created_on: string;
  public last_modified_by: string;
  public last_modified_on: string;
  public accepted: number;
  public updated_on: string;
  public updated_by: string;
  /** Request-only paging for search. */
  public limit?: number;
  public offset?: number;
}
